import React from 'react'
import PropTypes from 'prop-types'
import shortid from 'shortid'
import classnames from 'classnames'

import {FormGroup, FormLabel, FormController} from './formInputStyles'

const FormControlSelect = ({options, label, labelClass, groupClass, ...props}) => {

    return (
        <FormGroup className={groupClass}>
        
            {label && <FormLabel className={classnames(labelClass)}>{label}</FormLabel>}

            <FormController {...props} as="select" size="lg">

                {Object.keys(options).map((optionValue) => <option key={shortid.generate()} value={optionValue}>{options[optionValue]}</option>)}
            
            </FormController>
        
        </FormGroup>
    )
}

FormControlSelect.propTypes = {
    onChange: PropTypes.func.isRequired,
    defaultValue: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    options: PropTypes.object.isRequired,
    label: PropTypes.string,
    labelClass: PropTypes.string,
    groupClass: PropTypes.string
}

export default FormControlSelect
